<template lang="pug">
.wrapper
  .bg
    div(v-for="(ball, i) in bgBallAttr", v-bind="ball", :key="i")
  .container
    .header
      .title 文件清单
      .controls
        el-radio-group(v-model="viewType", size="mini", @change="onViewChange")
          el-radio-button(v-for="{ id, cnName } in views", :key="id", :label="id") {{ cnName }}
    .file-list(v-if="isList")
      el-table.jy-table(height="100%", :data="pageList")
        el-table-column(label="序号", width="50px", type="index", :index="pageStartIndex + 1", align="center")
        el-table-column(v-slot="{ row }", label="文件名称", prop="fullName", show-overflow-tooltip)
          .file-item(@click="preViewFile(row)")
            FileIcon(:row="row", @updateLight="updateLight")
            FileName(:name="row.absolutFolderPathName")
        el-table-column(label="上传人", width="150px", prop="checkInUser", align="center")
        el-table-column(label="最后更新时间 ", prop="checkInDate", width="150px", align="center")
    .file-tree(v-else)
      .share-plain(v-if="isShare")
        el-form(size="mini", label-width="85px")
          el-form-item(label="", label-width="0")
            .share-title {{ flowInfo.title }}
          el-form-item(label="分享链接：")
            a.link(:href="shareUrl", target="_BLANK", :title="flowInfo.title") {{ shareUrl }}
            i.copy.el-icon-document-copy(@click="copyUrl")
          el-form-item(label="二维码：")
            .qr-img(ref="qr")
      el-tree(v-slot="{ data }", default-expand-all, node-key="folderId", :data="fileTree", :props="treeProps")
        .file-item(@click="preViewFile(data)")
          FileIcon(:row="data", :icon-size="22", @updateLight="updateLight")
          FileName(:name="data.folderName")
    .footer
      el-pagination(v-if="isList", background, :page-size="pageSize", :current-page.sync="pageIndex", :total="fileList.length", layout="total, prev, pager, next, jumper")
</template>
<script>
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import FileName from "@/CommonDP/components/FileList/fileName.vue";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import { get, random, set } from "lodash-es";
import { getServerFiles, pathSeparator, separator } from "./utils";
import flowService from "@/CommonDP/service/flow-service";
import QRCode from "qrcodejs2";
export default {
  directives: {},
  components: { FileName, FileIcon },
  props: {
    preId: { default: "", type: String },
    path: { default: "", type: String }
  },
  data() {
    return {
      fileList: [],
      treeProps: { label: "folderName" },
      viewType: 1,
      pageIndex: 1,
      pageSize: 5,
      title: "",
      flowInfo: {},
      mouse: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    views() {
      const list = [
        { id: 1, cnName: "列表模式" },
        { id: 2, cnName: "文档目录模式" }
      ];
      this.isPreView || list.push({ id: 3, cnName: "分享" });
      return list;
    },
    shareUrl() {
      const {
        flowInfo: { path },
        $router,
        $route: { name }
      } = this;
      const url = $router.resolve({ name, query: { path }}).href;
      return new URL(url, location.href).href;
    },
    bgBall() {
      const { innerHeight, innerWidth } = window;
      return Array.from({ length: random(4, 6) }, () => {
        const size = random(80, 360);
        return {
          blur: size < 100,
          type: "blue-ball",
          size,
          mouseK: random(-0.05, 0.05),
          duration: random(40, 30),
          delay: random(0, -20),
          top: ((Math.cos(random(0, Math.PI * 2)) + 1) / 2) * innerHeight - size,
          left: ((Math.cos(random(0, Math.PI * 2)) + 1) / 2) * innerWidth - size
        };
      });
    },
    maskBall() {
      const { innerHeight, innerWidth } = window;
      return Array.from({ length: 2 }, (_, index) => {
        const size = random(innerWidth * 0.7, innerWidth * 1.1);
        return {
          type: "mask-ball",
          size,
          mouseK: 0,
          left: random(-size * 0.5, innerWidth * 0.8),
          top: index ? random(size * -0.8, size * -0.9) : random(innerHeight * 0.9, innerHeight * 0.75)
        };
      });
    },
    bgBallAttr() {
      const {
        bgBall,
        maskBall,
        mouse: { x, y }
      } = this;
      return [...bgBall, ...maskBall].map((ball) => {
        const attrs = {
          class: ball.type,
          style: {
            width: ball.size + "px",
            height: ball.size + "px",
            left: ball.left + ball.mouseK * (ball.left - x) + "px",
            top: ball.top + ball.mouseK * (ball.top - y) + "px"
          }
        };
        if (ball.blur) set(attrs, "style.filter", "blur(29px)");
        if (ball.duration) set(attrs, "style.--duration", ball.duration + "s");
        if (ball.delay) set(attrs, "style.--delay", ball.delay + "s");
        return attrs;
      });
    },
    fileTree() {
      const folderMap = {};
      const pIdMap = {};
      const { fileList } = this;
      for (const file of fileList) {
        const { folderId: fileId, absolutFolderPathId: fullIdPath, absolutFolderPathName: fullName } = file;
        folderMap[fileId] = file;
        if (fullIdPath) {
          const ids = fullIdPath.split(pathSeparator);
          const names = fullName.split(pathSeparator);
          for (let i = ids.length - 1; i >= 0; i--) {
            const folderId = ids[i];
            pIdMap[folderId] = ids[i - 1];
            if (folderId && !folderMap[folderId]) {
              const folderName = names[i];
              folderMap[folderId] = { folderName, isFolder: 1, folderId, children: [] };
            }
          }
        }
      }
      return Object.values(folderMap)
        .map((f) => {
          const pid = pIdMap[f.folderId];
          if (pid) {
            const pFolder = folderMap[pIdMap[f.folderId]];
            pFolder && pFolder.children.push(f);
          }
          return f;
        })
        .filter(({ folderId }) => !pIdMap[folderId]);
    },
    pageList() {
      const { pageStartIndex, pageSize, fileList } = this;
      return fileList.slice(pageStartIndex, pageStartIndex + pageSize);
    },
    pageStartIndex() {
      const { pageIndex, pageSize } = this;
      return pageIndex * pageSize - pageSize;
    },
    isPreView() {
      return this.preId;
    },
    isTree() {
      return this.viewType === 2;
    },
    isShare() {
      return this.viewType === 3;
    },
    isList() {
      return this.viewType === 1;
    },
    fieldInfo() {
      const { path = "" } = this;
      const index = path.indexOf(".");
      return { flowId: path.slice(0, index), field: path.slice(index + 1) };
    }
  },
  created() {
    this.getFileList();
    document.addEventListener("mousemove", this.setMouseDiff);
  },
  destroyed() {
    document.removeEventListener("mousemove", this.setMouseDiff);
  },
  methods: {
    onViewChange() {
      if (this.isShare) {
        this.updateQr(this.shareUrl);
      }
    },
    async copyUrl() {
      await this.$copyText(this.shareUrl);
      this.$message.success("链接复制成功!");
    },
    async openShare() {
      this.viewType = 3; // 分享页面
      await this.$nextTick();
      this.updateQr(this.shareUrl);
    },
    updateQr(text) {
      const el = this.$refs.qr;
      if (text) {
        new QRCode(el, {
          width: 80, // 二维码宽度，单位像素
          height: 80, // 二维码高度，单位像素
          text // 生成二维码的链接
        });
      }
    },
    async getFlowFile() {
      const {
        fieldInfo: { flowId, field }
      } = this;
      const { data } = await flowService.getBusinessForm(flowId);
      this.flowInfo.title = data.flowInfo.title;
      this.flowInfo.path = this.path;
      const ids = get(data, `object.${field}`);
      const idList = ids ? ids.split(separator) : [];
      const fileList = await getServerFiles(idList);
      this.fileList = fileList;
    },
    setMouseDiff(e) {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
    },
    preViewFile(row) {
      const { status, isFolder, folderId: fileId, fileVersion: versionId = 1, fileType } = row;
      if (isFolder) return;
      const data = { status, fileId, versionId, fileType };
      filePreviewV1(data, this.fileList);
    },
    getFileList() {
      if (this.isPreView) {
        this.getPreFile();
      } else {
        this.getFlowFile();
      }
    },
    async updateLight(row, type) {
      const prjId = row.prjId;
      if (!prjId) return this.$message.success("轻量化失败");
      const messageType = type === 1 ? "优先轻量化操作" : "重新轻量化操作";
      await docService.updateLight(prjId, row.folderId, row.fileVersion);
      row.status = "4";
      this.$message.success(`${messageType}成功`);
    },
    getPreFile() {
      const url = `blob:${window.location.origin}/${this.preId}`;
      fetch(url)
        .then((res) => res.text())
        .then((json) => {
          const data = JSON.parse(json);
          this.fileList = data;
        })
        .catch(() => {
          this.$message.error("未获取到待预览数据");
        });
    }
  }
};
</script>
<style lang="scss" scoped src="./page.scss">
</style>
